module.exports = __webpack_public_path__ + "static/banner_mob-9c5a1d12784eaf46da60becca2640fe7.jpg";